import SubscribeButtons from "@/components/ui/SubscribeButtons";
import { ZodiacDomain } from "@/types/Zodiac";
import zodiacBackground from "@/assets/img/d_start_background.png";

interface ZodiacPrognosisFreeProps {
  navigateToSubscribe: () => void;
  navigateToTelegram: () => void;
  zodiac: ZodiacDomain | null;
}

export const ZodiacPrognosisFree = ({
  navigateToSubscribe,
  navigateToTelegram,
  zodiac,
}: ZodiacPrognosisFreeProps) => {
    
  return (
    <div className="flex flex-col items-center flex-1 px-4 pb-6 w-full max-w-[430px] mx-auto h-screen "
    style={
        {
          backgroundImage: `url(${zodiacBackground})`,
          backgroundSize: "430px 100%",
          backgroundPosition: "center",
          backgroundRepeat: "repeat-x",
        }}  >
      <img
        src={zodiac?.image}
        alt={zodiac?.name}
        className="w-60 object-contain mt-12"
      />
      <div className="text-white text-lg  mb-4 mt-4">{zodiac?.name.toUpperCase()}</div>
      {/* Скроллируемый текстовый блок */}
      <div className="w-full flex-1 min-h-[120px] max-h-[350px] overflow-y-auto text-white text-sm leading-relaxed text-center mb-6 hide-scrollbar">
        Оформите любой вариант подписки, чтобы получать зодиакальный
        астрологический прогноз от нашего астролога.
        <br />
        <br />В данном разделе вы получите общий Зодиакальный прогноз
        относительно представителей вашего знака и он представляет из себя
        усредненный вектор, который задает «характер недели». И который
        объясняет, для каких дел эта неделя лучше всего подходит, а какие лучше
        отложить на потом. Такой усредненный "прогноз астрологической погоды"
        действительно подходит для всех. Ведь он подобно компасу, обозначает
        общие тенденции, указывает наилучшее направление, а также предупреждает,
        в какую сторону идти не стоит. Ну, а вы уже, как в случае с компасом или
        навигатором, сами вольны выбирать свой маршрут.
        <br />
        <br />
        Индивидуальный же прогноз составляется под конкретного человека, в этом
        случае надо знать не только дату рождения, но время и место рождения.
        Такой прогноз может предсказать конкретные события в вашей жизни, и
        ответит на те вопросы, которые вы зададите. С такой услугой вы сможете
        обратиться ко мне на индивидуальной консультации или вытянув Счастливую
        карту и в качестве бонуса получите скидку в 10% на следующий прогноз.
        <br />
        <br />С уважением, ваш астролог Татьяна Данченкова!
      </div>

      <SubscribeButtons
        buttonText="Подписки"
        className="pb-12"
        onButtonClick={navigateToSubscribe}
        onTelegramClick={navigateToTelegram}
      />
    </div>
  );
};
